/**
 * Extracts all <urlset>...</urlset> blocks from raw sitemap XML.
 */
export function extractSitemapSections(
    sitemapContent: string
): string[] {
    return (
        sitemapContent.match(
            /(?:<\?xml[\s\S]*?\?>\s*)?<urlset[\s\S]*?<\/urlset>/gi
        ) || []
    );
}